import React, { useEffect, Suspense, useRef, useState } from "react";
import { Link } from "react-router-dom";
import homepageAPI from "../../api/homepageApi";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { ArrowRight } from "lucide-react";
import Card from "../categories/Card";
import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "./Shared/CustomSwiper";
import CrystalFeatureSection from "./Feature";
import { Col, Container, Row } from "react-bootstrap";
import ProductCard from "../products/ProductCard";
import CategoryCard from "../categories/Card";
import Banner from "./Banner";

const Home = () => {
  const { siteConfig } = useSiteConfig();
  const [banner, setBanner] = useState([]);
  const [category, setCategory] = useState([]);
  const [bestSeller, setBestSeller] = useState([]);
  const [trending, setTrending] = useState([]);

  useEffect(() => {
    fetchHomepageData();
  }, []);

  const CACHE_TIME = 3 * 60 * 1000;

  const applyData = (result) => {
    setBanner(result?.banner || []);
    setCategory(result?.category || []);
    setBestSeller(result?.products?.bestseller || []);
    setTrending(result?.products?.trending || []);
  };

  const fetchHomepageData = async () => {
    try {
    //   const cached = sessionStorage.getItem("homeData");
    //   const parsed = cached ? JSON.parse(cached) : null;

    //   if (parsed?.data) {
    //     applyData(parsed.data);
    //   }

    //   const isExpired = !parsed || Date.now() - parsed.timestamp > CACHE_TIME;

    //   if (isExpired) {
        const res = await homepageAPI.homepage_list();

        if (res.code === 200) {
          sessionStorage.setItem(
            "homeData",
            JSON.stringify({
              data: res.data,
              timestamp: Date.now(),
            }),
          );

          applyData(res.data);
      //   }
      }
    } catch (error) {
      console.error("Home API Error:", error);
    }
  };

  const bannerInfo = banner[0];
  const categoryInfo = category[0];
  const bestSellerInfo = bestSeller[0];

  return (
    <>
      {banner && banner.length > 0 && (
        <Suspense fallback={<div></div>}>
          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={10}
            slidesPerView={1}
            autoplay={{ delay: 3000 }}
            Pagination={true}
          >
            {banner.map((banner, index) => (
              <SwiperSlide key={index}>
                <Banner item={banner} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Suspense>
      )}

      <CrystalFeatureSection />

      {category && category.length > 0 && (
        <section className="custom-category-section main-section">
          <div className="container">
            <div className="d-flex justify-content-between align-items-end mb-5">
              <div>
                <h2 className="mt-2 mb-0 section-title">Our Category</h2>
              </div>
              <Link to="/categories" className="view-all-link">
                View All Category
              </Link>
            </div>

            <Suspense fallback={<div></div>}>
              <Swiper
                spaceBetween={10}
                slidesPerView={2}
                breakpoints={{
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  992: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                }}
              >
                {category.map((category, index) => (
                  <SwiperSlide key={index}>
                    <CategoryCard item={category} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </Suspense>
          </div>
        </section>
      )}

      <div className="middle-banner">
        <Container className="p-0">
          <Row className="g-0 align-items-stretch">
            <Col md={7}>
              <div className="spotlight-image-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/middlbanner.webp`}
                  alt="Royal Agate"
                  className="spotlight-image"
                  loading="lazy"
                />
              </div>
            </Col>

            <Col md={5}>
              <div className="spotlight-text-wrapper">
                <div className="spotlight-tag-row">
                  <span className="spotlight-line"></span>
                  <span className="spotlight-tagline">Timeless Elegance</span>
                </div>

                <h2 className="spotlight-heading">
                  The Power Of Natural Stones
                </h2>

                <p className="spotlight-description">
                  Natural Stones Can Bring Change to Your Life Just You Need To
                  Have Faith
                </p>

                <Link to="/shop" className="spotlight-btn">
                  <span>Discover More</span>
                  <ArrowRight size={16} className="spotlight-btn-icon" />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* bestsellers */}
      {bestSeller && bestSeller.length > 0 && (
        <section className="bestsellers-section main-section">
          <div className="container ">
            <div className="d-flex justify-content-between align-items-end mb-5">
              <div>
                <h2 className="mt-2 mb-0 section-title">Best Sellers</h2>
              </div>
              <Link to="/shop" className="view-all-link">
                View All Products
              </Link>
            </div>

            <Row className="g-3">
              <Suspense fallback={<div></div>}>
                {bestSeller.map((product, index) => (
                  <Col lg={3} md={6} sm={6} xs={6} key={product.id || index}>
                    <ProductCard item={product} />
                  </Col>
                ))}
              </Suspense>
            </Row>
          </div>
        </section>
      )}

      <section className="cta-banner-2">
        <Container>
          <Row className="align-items-center">
            {/* LEFT IMAGE */}
            <Col md={12} className="mb-4 mb-md-0">
              <div className="banner-media-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/secmiddlebanner.png`}
                  alt="Royal agate"
                  className="banner-media"
                  loading="lazy"
                />
              </div>
            </Col>

            {/* RIGHT CONTENT */}
          </Row>
        </Container>
      </section>

      {/* trending */}
      {trending && trending.length > 0 && (
        <section className="bestsellers-section main-section">
          <div className="container ">
            <h2 className="section-title text-center mb-4">
              Trending Products
            </h2>
            <Row className="g-3">
              <Suspense fallback={<div></div>}>
                {trending.map((product, index) => (
                  <Col lg={3} md={6} sm={6} xs={6} key={[product._id || index]}>
                    <ProductCard item={product} />
                  </Col>
                ))}
              </Suspense>
            </Row>
          </div>
        </section>
      )}
    </>
  );
};

export default Home;
